import { spacingPrimitive } from "./spacingPrimitive";

export const spacing = {
	spacing_none: spacingPrimitive[0],
	spacing_xxs: spacingPrimitive["0.5"],
	spacing_xs: spacingPrimitive[1],
	spacing_sm: spacingPrimitive["1.5"],
	spacing_md: spacingPrimitive[2],
	spacing_lg: spacingPrimitive[3],
	spacing_xl: spacingPrimitive[4],
	spacing_2xl: spacingPrimitive[5],
	spacing_3xl: spacingPrimitive[6],
	spacing_4xl: spacingPrimitive[8],
	spacing_5xl: spacingPrimitive[10],
	spacing_6xl: spacingPrimitive[12],
	spacing_7xl: spacingPrimitive[16],
	spacing_8xl: spacingPrimitive[20],
	spacing_9xl: spacingPrimitive[24],
	spacing_10xl: spacingPrimitive[32],
	spacing_11xl: spacingPrimitive[40],
};
